import React from 'react';
import ShowcaseCard from './ShowcaseCard';

class Work extends React.Component {
	render () {
		return (
			<section id="work" name="work" className="section u-pt">
			  <div className="container">
				<div className="row">
					<div className="sm-12 col">
						<h2 className="heading--primary u-mb">Work</h2>
					</div>
					<div className="sm-12 lg-6 col u-mb">
						<ShowcaseCard 
							title = 'FundThrough'
							description = 'Invoice Financing Platform'
							imageSource = {require('./../images/fundthrough.png')}
							imageAlt = 'FundThrough HomePage'
							techUsed = {['AngularJS', 'JavaScript', 'HTML5', 'CSS3 / SASS', 'Grunt / Gulp', 'PHP (WordPress)', 'Ruby on Rails']}
						/>
					</div>
					<div className="sm-12 lg-6 col u-mb">
						<ShowcaseCard 
							title = 'Gale Partners'
							description = 'Marketing Agency'
							imageSource = {require('./../images/gale.png')}
							imageAlt = 'Gale Partners HomePage'
							techUsed = {['VueJS', 'JavaScript', 'HTML5', 'CSS3 / LESS', 'Gulp']}
						/>
					</div>
					<div className="sm-12 lg-6 col u-mb">
						<ShowcaseCard 
							title = 'Avalon Organics'
							description = 'Organic Beauty Care'
							imageSource = {require('./../images/avalon.png')}
							imageAlt = 'Avalon Organics HomePage'
							techUsed = {['Bootstrap', 'JavaScript', 'HTML5', 'CSS3 / LESS', 'Django', 'Jquery']}
						/>
					</div>
					<div className="sm-12 lg-6 col u-mb">
						<ShowcaseCard 
							title = 'Sensible Portions'
							description = 'Organic Snacks'
							imageSource = {require('./../images/sensible-portions.png')}
							imageAlt = 'Sensible Portions HomePage'
							techUsed = {['Bootstrap', 'JavaScript', 'HTML5', 'CSS3 / LESS', 'Django', 'Jquery']}
						/>
					</div>
			    </div>
			  </div>
			</section>
		)
	}
}

export default Work;


// WEBPACK FOOTER //
// ./src/components/Work.js